<template>
  <section id="buckets">
    <div class="demo">
      <fieldset class="buckets" data-toggle="tooltip" data-placement="bottom" data-original-title="Buckets" aria-label="3 buckets" @click="selectBucket">
        <div class="bucket-1">
          <input type="checkbox" name="bucket" id="bucket-1" value="option2">
          <label for="bucket-1">
            <span class="sr-only">
              Green</span>
          </label>
        </div>
        <div class="bucket-2">
          <input type="checkbox" name="bucket" id="bucket-2" value="option1">
          <label for="bucket-2">
            <span class="sr-only">
              Orange</span>
          </label>
        </div>
        <div class="bucket-3">
          <input type="checkbox" name="bucket" id="bucket-3" value="option3">
          <label for="bucket-3">
            <span class="sr-only">
              Red</span>
          </label>
        </div>
      </fieldset>
    </div>
    <section class="md" v-html="mdfile"></section>
  </section>
</template>

<script>
import mdfile from "@/docs/forms/buckets.md";
export default {
  name: "buckets",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.forms.buckets.name);
    this.$emit("update-tagline", this.$root.yamlData.forms.buckets.description);
  },
  methods: {
    selectBucket: function(e){
      e = e || event;
      var cb = e.srcElement || e.target;
      if (cb.type !== 'checkbox') {
        return true;
      }
      var name = e.srcElement.name;
      var cbxs = document.getElementsByName(name),
        i = cbxs.length;
      while (i--) {
        if (cbxs[i].type && cbxs[i].type == 'checkbox' && cbxs[i].id !== cb.id) {
          cbxs[i].checked = false;
        }
      }
    }
  },
  data() {
    return {
      mdfile
    };
  }
};

</script>
